export default __webpack_public_path__ + "static/media/rolesContentDesign.062ab830.svg";